module.exports = __webpack_public_path__ + "static/img/gsjs_gsjs.a1653fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/gsjs_gsjs.png
// module id = uhn2
// module chunks = 0